import { IFlightMarkersState } from "../modules/flightMarkers/flightMarkersReducer";
import { IGCPRequestState } from "../modules/gcpRequest/reducer";
import { ISiteState } from "../modules/site/reducer";
import {
  getCorruptedMarkerRows,
  getExistingGcpRows,
  getPlacedMarkersRows,
  getRemeasureOnlyRows,
  getSuggestedMarkerRows,
  IExportType,
} from "./exportGcpRows";

export const getAllGcps = (
  gcpRequestState: IGCPRequestState,
  flightMarkersState: IFlightMarkersState,
  siteState: ISiteState,
  exportType: IExportType,
) => {
  const suggestedFlightMarkersRows = getSuggestedMarkerRows(
    gcpRequestState,
    flightMarkersState,
    siteState,
    exportType,
  );
  const existingGcpRows = getExistingGcpRows(
    gcpRequestState,
    siteState,
    exportType,
  );
  const corruptedFlightMarkersRows = getCorruptedMarkerRows(
    gcpRequestState,
    flightMarkersState,
    siteState,
    exportType,
  );
  const placedMarkers = getPlacedMarkersRows(
    flightMarkersState,
    siteState,
    exportType,
    // pass gcp request state to filter out markers that we already got from getCorruptedMarkerRows
    gcpRequestState,
  );

  return [
    ...existingGcpRows,
    ...suggestedFlightMarkersRows,
    ...corruptedFlightMarkersRows,
    ...placedMarkers,
  ];
};

export const getToBeCheckedGcps = (
  gcpRequestState: IGCPRequestState,
  flightMarkersState: IFlightMarkersState,
  siteState: ISiteState,
  exportType: IExportType,
) => {
  const suggestedFlightMarkersRows = getSuggestedMarkerRows(
    gcpRequestState,
    flightMarkersState,
    siteState,
    exportType,
  );
  const corruptedFlightMarkersRows = getCorruptedMarkerRows(
    gcpRequestState,
    flightMarkersState,
    siteState,
    exportType,
  );
  const existingGcpRows = getExistingGcpRows(
    gcpRequestState,
    siteState,
    exportType,
  );
  const remeasuredGcpRows = getRemeasureOnlyRows(
    flightMarkersState,
    siteState,
    exportType,
    // pass gcp request state to filter out markers that we already got from getCorruptedMarkerRows
    gcpRequestState,
  );
  return [
    ...existingGcpRows,
    ...suggestedFlightMarkersRows,
    ...corruptedFlightMarkersRows,
    ...remeasuredGcpRows,
  ];
};
